import { render, staticRenderFns } from "./module.vue?vue&type=template&id=f8a9f78c&scoped=true&"
import script from "./module.vue?vue&type=script&lang=js&"
export * from "./module.vue?vue&type=script&lang=js&"
import style0 from "./module.vue?vue&type=style&index=0&id=f8a9f78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a9f78c",
  null
  
)

export default component.exports